'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalHeader = require('react-bootstrap/lib/ModalHeader');

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ModalHeader2.default;